"use client";

import { scrollToTop } from "@homeinstead/shared";
import { createContext, use } from "react";

type LeadFormScrollTargetContextValue = {
  scrollStepRegionToTop: () => void;
};

// Defaults to the window so today's behavior (Continue scrolls the page) is
// unchanged when no provider is present. A fullscreen takeover can later
// provide a value that scrolls its own scrollable body instead.
const LeadFormScrollTargetContext =
  createContext<LeadFormScrollTargetContextValue>({
    scrollStepRegionToTop: () => scrollToTop(),
  });

function useLeadFormScrollTarget(): LeadFormScrollTargetContextValue {
  return use(LeadFormScrollTargetContext);
}

export { LeadFormScrollTargetContext, useLeadFormScrollTarget };
